<template>
  <tr>
    <component :is="elementType">
      {{ title }}

      <template v-if="subtitle">
        <br />
        <small>
          <em>{{ subtitle }}</em>
        </small>
      </template>

      <template v-if="description">
        <br />
        <small>{{ description }}</small>
      </template>
    </component>

    <component v-if="anyQuantifiable" :is="elementType" class="text-center">
      <input
        v-if="quantifiable"
        :min="minQuantity"
        type="number"
        :value="quantity"
        @blur="onQuantityBlur"
        @focus="onQuantityFocus"
        class="form-control estimates-table-row__input"
      />

      <template v-else>{{ quantity ? '—' : '' }}</template>
    </component>

    <component :is="elementType" class="text-right">
      {{ formattedAmount }}

      <template v-if="discount">
        <br />
        <small>
          <em>{{ formattedDiscount }}</em>
        </small>
      </template>
    </component>
  </tr>
</template>

<script>
export default {
  name: 'estimates-table-row',
  props: {
    amount: {
      type: Number,
      required: true,
    },
    anyQuantifiable: {
      type: Boolean,
    },
    bold: {
      type: Boolean,
    },
    currency: {
      type: String,
      default: 'USD',
    },
    discount: {
      type: Number,
    },
    quantifiable: {
      type: Boolean,
    },
    quantity: {
      type: Number,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
    },
    description: {
      type: String,
    },
  },
  data() {
    return {
      minQuantity: 0,
      quantityChangeTimeout: null,
    };
  },
  computed: {
    elementType() {
      return this.bold ? 'th' : 'td';
    },
    formattedAmount() {
      return new Intl.NumberFormat('en-US', {style: 'currency', currency: this.currency}).format(this.amount / 100);
    },
    formattedDiscount() {
      return (
        this.discount &&
        new Intl.NumberFormat('en-US', {style: 'currency', currency: this.currency}).format(-this.discount / 100)
      );
    },
  },
  methods: {
    onQuantityBlur(event) {
      const quantity = Number(event.target.value);

      if (quantity >= this.minQuantity && quantity !== this.quantity) {
        this.quantityChangeTimeout = window.setTimeout(() => this.$emit('quantity-change', quantity), 2000);
      }
    },
    onQuantityFocus() {
      window.clearTimeout(this.quantityChangeTimeout);
    },
  },
};
</script>

<style lang="scss" scoped>
.estimates-table-row {
  &__input {
    width: 4em;
  }
}
</style>
